import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thanku',
  templateUrl: './thanku.component.html',
  styleUrls: ['./thanku.component.scss']
})
export class ThankuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
